class MFRProductCarousel {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            image: ".product-carousel__item-image",
            item: ".product-carousel__item",
            isSelected: ".product-carousel__item.is-selected",
            flickitySlider: ".flickity-slider",
            formWrapper: ".product-carousel__form-wrapper",
            smallText: ".product-carousel__form-small-text",
            title: ".product-carousel__form-title",
            desc: ".product-carousel__form-desc",
            button: ".product-carousel__form-button"
        }

        this.init();
        this.state;
    }

    init() {
        this.$image = this.$element.find( this.selectors.image );
        this.$item = this.$element.find( this.selectors.item );
        this.$flickitySlider = this.$element.find( this.selectors.flickitySlider );
        this.$formWrapper = this.$element.siblings( this.selectors.formWrapper );
        
        this.initCarousel();
    }

    initCarousel() {
        this.$carousel = this.$element.flickity( {
            wrapAround: true,
            pageDots: false,
            imagesLoaded: true
        } );

        this.initCarouselEvents();
    }

    initCarouselEvents() {
        this.$carousel.on( "select.flickity", () => {
            this.__handleCarouselChange();
            this.updateFormElements();
        } );
    }

    __handleCarouselChange( index ) {
        const alongsideClass = "alongside-selected";
        const carousel = this.$element.data( "flickity" );
        if( !carousel ) return;
        const selectedIndex = carousel.selectedIndex;
        let beforeIndex = selectedIndex == 0 ? carousel.cells.length - 1 : selectedIndex - 1;
        let afterIndex = selectedIndex == carousel.cells.length - 1 ? 0 : selectedIndex + 1;
        const beforeElement = this.$element.find( this.selectors.item + `[data-index="${ beforeIndex }"]` );
        const afterElement = this.$element.find( this.selectors.item + `[data-index="${ afterIndex }"]` );

        this.$item.removeClass( alongsideClass );
        beforeElement.addClass( alongsideClass );
        afterElement.addClass( alongsideClass );
        // this.$carousel.flickity( "reposition" );
    }

    updateFormElements() {
        const carousel = this.$element.data( "flickity" );
        if( !carousel ) return;

        const selectedIndex = carousel.selectedIndex;
        const selectedCell = this.$element.find( this.selectors.item + `[data-index="${ selectedIndex }"]` );

        this.animmateChange( this.selectors.smallText, selectedCell.find( this.selectors.smallText ).html() );
        this.animmateChange( this.selectors.title, selectedCell.find( this.selectors.title ).html() );
        this.animmateChange( this.selectors.desc, selectedCell.find( this.selectors.desc ).html() );
        this.animmateChange( this.selectors.button, selectedCell.find( this.selectors.button ).html(), false );
    }

    animmateChange( element, value, animate = true ) {
        const span = this.$formWrapper.find( element ).find( "span" );
        if( animate ) {
            // if( span.html() == value ) return;
            gsap.to( span, {
                yPercent: 100,
                duration: .4,
                ease: "power4.out",
                onComplete: () => {
                    span.html( value );
                    gsap.to( span, {
                        yPercent: 0,
                        duration: .8
                    } );
                }
            } );
        }
        else {
            span.html( value );
        }
    }
}